import { cx } from '@linaria/core';
import { units } from '@ui/css';
import { wrapper, horisontal, withoutHeadingSpacer } from './_page-content.style.js';
import { TaskHeading } from './atom.task-heading.js';
import { TaskContext } from './molecule.context.js';
import { TaskInputs } from './molecule.inputs.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function makePrintPageTaskChunk(task, entryKey, index, options) {
  const displayContentInColumns = !!task.guide.trim() && task.inputs.length > 0 && ["left", "right"].includes(task.alignment);
  const chunks = [{
    containerClassName: wrapper,
    content: options?.includeHeading ? /*#__PURE__*/jsx(TaskHeading, {
      index: index,
      task: task
    }) : /*#__PURE__*/jsx("div", {
      className: withoutHeadingSpacer
    })
  }];
  if (displayContentInColumns) {
    chunks.push({
      containerClassName: wrapper,
      columnGap: units.px(20),
      columns: task.alignment === "left" ? [{
        content: /*#__PURE__*/jsx(TaskContext, {
          task: task
        }, "context")
      }, {
        content: /*#__PURE__*/jsx(TaskInputs, {
          entryKey: entryKey,
          task: task
        }, "inputs")
      }] : [{
        content: /*#__PURE__*/jsx(TaskInputs, {
          entryKey: entryKey,
          task: task
        }, "inputs")
      }, {
        content: /*#__PURE__*/jsx(TaskContext, {
          task: task
        }, "context")
      }]
    });
  } else {
    chunks.push({
      content: /*#__PURE__*/jsx("div", {
        className: cx(wrapper, horisontal),
        children: task.alignment === "top" ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(TaskContext, {
            task: task
          }), /*#__PURE__*/jsx(TaskInputs, {
            task: task,
            entryKey: entryKey
          })]
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx(TaskInputs, {
            task: task,
            entryKey: entryKey
          }), /*#__PURE__*/jsx(TaskContext, {
            task: task
          })]
        })
      }, "content")
    });
  }
  return chunks;
}

export { makePrintPageTaskChunk };
//# sourceMappingURL=_page-content.js.map
